import React from 'react';
import { List } from 'antd';
import { connect } from 'react-redux';
import { thunkFetchEventPages } from '@/redux/actions';
import OmniPickerItem from './OmniPickerItem';

class PagePicker extends React.Component {
	componentDidMount = () => {
		const { fetchEventPages, eventID } = this.props;
		fetchEventPages(eventID, 'PagePicker - componentDidMount');
	};

	render = () => {
		const { handlePickItem, pages } = this.props;
		return (
			<List
				rowKey="id"
				dataSource={Object.values(pages)}
				renderItem={item => <OmniPickerItem handlePickItem={handlePickItem} item={item} />}
			/>
		);
	};
}

const msp = state => ({
	pages: state.pages,
});

const mdp = dispatch => ({
	fetchEventPages: (eventID, from) => dispatch(thunkFetchEventPages(eventID, from)),
});

export default connect(msp, mdp)(PagePicker);
